import React, { useEffect, useState } from 'react';
import { fetchCollection } from '../lib/cms';
import { fallbackSections, fallbackGallery } from '../data';
import { Helmet } from 'react-helmet-async';
import Navbar from '../components/Navbar';
import Hero from '../components/Hero';
import Section from '../components/Section';
import Gallery from '../components/Gallery';
import Footer from '../components/Footer';

export default function Home() {
  const [sections, setSections] = useState([]);
  const [galleryItems, setGalleryItems] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    async function loadData() {
      try {
        const [sectionsData] = await Promise.all([
          fetchCollection('page_sections')
        ]);
        setSections(sectionsData && sectionsData.length > 0 ? sectionsData : fallbackSections);
        setGalleryItems(fallbackGallery);
      } catch (error) {
        setSections(fallbackSections);
        setGalleryItems(fallbackGallery);
      } finally {
        setLoading(false);
      }
    }
    loadData();
  }, []);

  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-white">
        <div className="flex gap-2">
          <div className="w-4 h-4 bg-red-600 rounded-full animate-bounce" />
          <div className="w-4 h-4 bg-green-600 rounded-full animate-bounce [animation-delay:-0.15s]" />
          <div className="w-4 h-4 bg-black rounded-full animate-bounce [animation-delay:-0.3s]" />
        </div>
      </div>
    );
  }

  const heroSection = sections.find(s => s.section_id === 'hero-section-main');
  const membershipSection = sections.find(s => s.section_id === 'membership');
  const contributionSection = sections.find(s => s.section_id === 'contribution');
  const contactSection = sections.find(s => s.section_id === 'contact');

  return (
    <div className="bg-white">
      <Helmet>
        <title>DAPAO | Dansk-Palæstinensisk Aktions- & Oplysningsgruppe</title>
        <meta name="description" content="Støt ligestilling, dialog og solidaritet mellem danskere og palæstinensere. Bliv medlem af DAPAO for kun 200 kr. årligt og gør en forskel i dag!" />
      </Helmet>
      <Navbar />
      <Hero section={heroSection} />
      
      <Section 
        id="membership" 
        section={membershipSection} 
        reverse={true}
      />
      
      <Section 
        id="contribution" 
        section={contributionSection} 
        reverse={false}
        dark={true}
      />

      <Gallery items={galleryItems} />

      <Footer />
    </div>
  );
}
